module.exports = __webpack_public_path__ + "img/__reporting.105e63c9.svg";